import { httpClient } from 'core/net/http';
import * as v from 'valibot';
import { OverlayFileInfoSchema } from 'app/business-logic/domain-models/Blasting.schema';
import { LogManager } from 'core/logging/LogManager';

const logger = LogManager.getLogger('fetchTempOverlayFiles', { error: { logToServer: true } });

export const fetchTempOverlayFiles = async () => {
  const response = await httpClient.useInternalApi.asAuthorised().get('/configuration/blasting/scenarios/overlays');

  if (!response.isSuccess) {
    const errorMessage = 'Failed to fetch overlay files';
    logger.error(errorMessage);
    throw new Error(errorMessage);
  }

  const parsedData = v.safeParse(v.nullable(v.array(OverlayFileInfoSchema)), response.data);

  if (!parsedData.success) {
    const errorMessage = 'Failed to parse overlay files response';
    logger.error(errorMessage, parsedData.issues);
    throw new Error(errorMessage);
  }

  return parsedData.output ?? [];
};
